import { createLiveStore } from "../lib/live-store";
import type { AssetStatistics } from "../types/api";

interface AssetStatsData {
  stats: AssetStatistics | null;
}

export const useAssetStatsStore = createLiveStore<AssetStatsData>({
  topic: "assets.statistics",
  onSnapshot: (data) => ({ stats: data as AssetStatistics }),
  state: () => ({ stats: null }),
});
